import React from 'react';

export function ContactSkeleton() {
  return (
    <div className="flex p-5 w-full border border-gray-300 space-x-4">
      <div className="w-20 h-20 bg-gray-300 rounded animate-pulse" />
      <div className="flex-1">
        <div className="w-50 h-4 bg-gray-300 rounded animate-pulse" />
        <div className="mt-2 w-16 h-3 bg-gray-300 rounded animate-pulse" />
        <div className="mt-4 w-32 h-8 bg-gray-300 animate-pulse" />
      </div>
    </div>
  );
}
